import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { FCWithChildren } from '@/types'

import { APP_NAME } from '@/constants'

import App from '@/Components/App'
import { Environments } from '@/Components/EnvBanner'

const UnauthenticatedLayout: FCWithChildren<{ env?: Environments }> = ({
  env,
  children
}) => {
  return (
    <App env={env}>
      <Grid
        container
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          mt: 8
        }}
      >
        <Grid size={6}>
          <Stack gap={10} justifyContent="center" alignItems="center">
            <Box component="header" sx={{ textAlign: 'center' }}>
              <Typography
                variant="h1"
                sx={{
                  textTransform: 'uppercase',
                  color: 'primary.main',
                  lineHeight: 1
                }}
              >
                {APP_NAME}
              </Typography>
            </Box>
            {children}
          </Stack>
        </Grid>
      </Grid>
    </App>
  )
}

export default UnauthenticatedLayout
